import { scrollToElement } from '@cian/newbuilding-utils';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { setHash } from 'shared/utils/setHash';

import styles from './PikLogo.css';

type TPikLogoProps = {
  onLogoAnalyticsClick?: () => void;
};

export const PikLogo: FC<TPikLogoProps> = ({ onLogoAnalyticsClick }) => {
  const handleLogoClick = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();

      onLogoAnalyticsClick?.();
      setHash('');
      scrollToElement({ selector: 'body' });
    },
    [onLogoAnalyticsClick],
  );

  return (
    <a className={styles['container']} href="#" onClick={handleLogoClick}>
      <img alt="ПИК" height={16} src="https://static.cdn-cian.ru/media/images/pik_orange.svg" width={54} />
    </a>
  );
};
